import amenitiesList from '../src/components/listings/resources/amenities_list.json';

/** Default all amenity labels enabled when org has no `settings.amenities_filter` in API. */
export function defaultAmenitiesFilter() {
  return Object.keys(amenitiesList).reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {});
}

export function getAmenitiesFilter(brand) {
  const filter = brand?.settings?.amenities_filter;
  if (filter && typeof filter === 'object') {
    return filter;
  }
  return defaultAmenitiesFilter();
}

export function filterAmenitiesList(amenitiesListSource, brand) {
  const amenitiesFilter = getAmenitiesFilter(brand);
  return Object.fromEntries(
    Object.entries(amenitiesListSource).filter(([key]) => amenitiesFilter[key])
  );
}
